import React from "react";
import Vehicles from "../../../../src/Vehicules.json";
import { Form } from "react-bootstrap";
const VehiculesSelect = ({
  handleProductChange = () => {},
  selectedVehicle,
}) => {
  return (
    <div className='text-start'>
      <label className='text-start'>Marque</label>
      <Form.Select
        placeholder='select model'
        value={selectedVehicle}
        onChange={(e) => handleProductChange(e.target.value, "brand")}
      >
        {Vehicles.map(({ id, brand }) => (
          <option key={id}>{brand}</option>
        ))}
      </Form.Select>
    </div>
  );
};

export default VehiculesSelect;
